import React from 'react';
import { FacebookShareButton, LinkedinShareButton } from 'react-share';

import styled from '@emotion/styled';
import { IconRawSvg } from '../../../components/IconRawSvg';
import { VisibleOn } from '../../../components/VisibleOn';
import { media } from '../../../services/media';

interface ArticleShareProps {
    url: string;
    title?: string;
}

export const ArticleShare: React.FC<ArticleShareProps> = ({
    url,
    title = null,
}) => {
    return (
        <Wrapper>
            <VisibleOn tablet desktop>
                {title && <Title>{title}</Title>}
            </VisibleOn>
            {url && (
                <ButtonsWrapper>
                    <FacebookShareButton url={url}>
                        <SocialIcon name="facebookIcon" />
                    </FacebookShareButton>
                    <LinkedinShareButton url={url}>
                        <SocialIcon name="linkedinIcon" />
                    </LinkedinShareButton>
                </ButtonsWrapper>
            )}
        </Wrapper>
    );
};

const Wrapper = styled.div`
    ${media.min('xl')} {
        margin-bottom: 80px;
    }

    ${media.min('xxl')} {
        margin-bottom: 124px;
    }
`;

const Title = styled.h4`
    font-size: 24px;

    ${media.min('xl')} {
        font-size: 26px;
    }

    ${media.min('xxl')} {
        margin-left: 67px;
        margin-bottom: 46px;
    }
`;

const ButtonsWrapper = styled.div`
    display: flex;
    justify-content: center;

    ${media.min('md')} {
        justify-content: flex-start;
    }
`;

const SocialIcon = styled(IconRawSvg)`
    cursor: pointer;
    outline: none;
    width: 45px;
    height: 45px;
    margin-right: 15px;

    ${media.min('md')} {
        width: 63px;
        height: 63px;
    }

    ${media.min('xl')} {
        width: 83px;
        height: 83px;
    }

    path {
        fill: #8e99a8;
    }
`;
